import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ClienteService } from 'src/app/services/cliente.service';
import { ActivatedRoute } from '@angular/router';
import { trigger, style, state, transition, animate, keyframes } from '@angular/animations';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {

  public showModal = false;
  public codigo = '';
  public ciudadesconsulta: Array<any> =[];
  public tipoconsulta:  Array<any> =[];
 
  disabled = false;
  public params:any = {
  operacion: '',
  ciudad:'',
  tipo:'',
  banos:'',
  habitaciones:'',
  orden:''
};

  public id = 814;
  public deferredPrompt;
  public showDownLoadButton = false;
  public isNavCollapsed = true;

  constructor(private _navbarService : ClienteService,
              private router: Router,         
    ) {}


    enviar(){
      const codigo = this.codigo.trim();

      if(codigo === ''){
        this.router.navigate(['/app/inmuebles'], {queryParams: this.params});
      }
      else{
        this.router.navigate(['/app/detalle', codigo]);
      }
      this.cerrar();
    }

    limpiarFiltros(){
      this.codigo = '';
      this.disabled = false;
      this.params = {
        operacion: '',
        ciudad: '',
        tipo: '',
        banos: '',
        habitaciones: '',
        orden: ''
      };
    }

    getCodigo(event: Event){
      this.codigo = (<HTMLInputElement>event.target).value;
      if(this.codigo.trim() !== ''){
        this.disabled = true;
      }
      else{
        this.disabled = false;
      }
    }

  abrir() {
    console.log("abriendo");
    document.body.classList.add('box-collapse-open');
    document.body.classList.remove('box-collapse-closed');
  }

  cerrar(): void {
    console.log("cerrando");
    document.body.classList.add('box-collapse-closed');
    document.body.classList.remove('box-collapse-open');
  }
  
  ngOnInit(): void {
    this.obtener_ciudades();
    this.obtener_tipo();
  }

  navegarAdmin(){
    this.router.navigateByUrl('http://admin.tecnocompany.co/#/inicio/')
  }

  modal(){
    this.showModal = !this.showModal;
  

  }
  hideModal(){
    this.showModal = false;
  }
  
  cerrarModal(event){
    this.showModal = event;
  }

  toggleNav(): void {
    this.isNavCollapsed = !this.isNavCollapsed;
  }

  hiddeNav(): void {
    this.isNavCollapsed = true;
  }

  obtener_ciudades(){
    this._navbarService.obtener_ciudades().subscribe(
      response =>{
        this.ciudadesconsulta = response.data;
        console.log(this.ciudadesconsulta);
      }
    )
  }

  obtener_tipo(){
    this._navbarService.obtener_tipo().subscribe(
      response =>{
        this.tipoconsulta = response.data;
        console.log(this.ciudadesconsulta);
      }
    )
  }
}